import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function PendingApprovals() {
  const [list, setList] = useState([]);
  const load = () => api.get("/personnel/pending").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    await api.post(`/personnel/${id}/${action}`);
    toast.success(action === "approve" ? "Onaylandı" : "Reddedildi");
    load();
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Kayıt Talepleri</div>
        <h1 className="font-display text-3xl font-bold mt-1">Onay Bekleyenler</h1>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {list.map((p) => (
          <Card key={p.id}>
            <CardContent className="p-6">
              <div className="flex justify-between items-start">
                <div>
                  <div className="font-display font-bold text-lg">{p.first_name} {p.last_name}</div>
                  <div className="text-sm text-muted-foreground">{p.email} · {p.phone}</div>
                  <div className="text-sm mt-2">{p.department} / {p.position}</div>
                  <div className="text-xs mt-1 uppercase tracking-[0.2em]">Rol: {p.role}</div>
                </div>
                {p.signature && <img src={p.signature} alt="imza" className="h-16 object-contain" />}
              </div>
              <div className="flex gap-2 justify-end mt-4">
                <Button size="sm" variant="outline" onClick={() => act(p.id, "reject")} data-testid={`reject-${p.id}`}>Reddet</Button>
                <Button size="sm" onClick={() => act(p.id, "approve")} data-testid={`approve-${p.id}`}>Onayla</Button>
              </div>
            </CardContent>
          </Card>
        ))}
        {list.length === 0 && <div className="text-muted-foreground">Bekleyen talep yok.</div>}
      </div>
    </div>
  );
}
